<template>
  <div
    :class="'rectangle-item ' + item.itemType"
    :style="getPos"
    @mousedown="mouseDown($event)"
    @mouseup="mouseUp($event)"
    @click="markAsActive($event)"
  >
    <component
      :is="rectangleComponent"
      :active="isActive"
      :unit="unit"
      :item="item"
      :index="index"
    ></component>
    <div v-show="!isActive" class="dragHandler"></div>
    <div
      v-if="item.rotatable"
      class="ui-rotatable-handle ui-draggable"
      @mousedown="mouseDown($event)"
      @mouseup="mouseUp($event)"
    ></div>
    <u v-if="isActive"></u>
  </div>
</template>
<script>
import { useEditorFilesStore } from "@/stores/modules/editorFiles";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

import DummyImage from "./DummyImage";
import CropImage from "./CropImage";
export default {
  props: ["item", "index", "updateItem"],
  components: {
    dummyimage: DummyImage,
    cropimage: CropImage
  },
  computed: {
    ...mapState(useImageEditorStore, ["getActiveElement", "getEditor"]),
    unit: function () {
      var imageUnit = this.getEditor.dim.imageDimByFormat.unit;
      var canvasUnit = this.getEditor.dim.canvasDimByFormat.unit;
      return imageUnit / canvasUnit;
    },
    activeElement: function () {
      return this.getActiveElement;
    },
    isActive: function () {
      return (
        this.item.elementType === this.activeElement.type &&
        this.index === this.activeElement.index
      );
    },
    getPos: function () {
      //if( this.ready ){
      var result = {
        left: (this.item.left - this.item.offsetX) * this.unit + "px",
        bottom: (this.item.bottom - this.item.offsetY) * this.unit + "px",
        width: this.item.width * this.unit + "px",
        height: this.item.height * this.unit + "px"
      };
      return result;
      //}
    },
    /*
    isCropImage() {
      return this.item.type === "image";
    },*/
    isCropImage() {
      return this.item.type === "dummy" || this.item.type === "steckdosen";
    },
    rectangleComponent() {
      switch (this.item.type) {
        case "image":
          switch (this.item.subtype) {
            case "cropimage":
              return "cropimage";
            case "dummyimage":
              return "dummyimage";
            default:
              return null;
          }
        default:
          return null;
      }
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["addToActiveElement"]),
    markAsActive: function (event) {
      if (this.nonClickable) return;
      this.addToActiveElement({
        type: this.item.elementType,
        subtype: this.item.subtype,
        index: this.index
      });
    },
    mouseDown: function (event) {
      if (this.item.movable || this.item.resizable || this.item.rotatable) {
        togglePep("#format-layer", true);
      }
    },
    mouseUp: function (event) {
      if (this.item.movable || this.item.resizable || this.item.rotatable) {
        togglePep("#format-layer", false);
      }
    },
    _updateOndrag: function (event, ui) {
      ui.helper.css("bottom", "");

      this.updateItem(this.index, {
        left: ui.position.left / this.unit + parseFloat(this.item.offsetX),
        bottom:
          parseFloat(ui.helper.css("bottom")) / this.unit +
          parseFloat(this.item.offsetY)
      });
    },
    _updateOnResize: function (event, ui) {
      ui.helper.css("bottom", "");
      this.updateItem(this.index, {
        width: ui.size.width / this.unit,
        height: ui.size.height / this.unit,
        left: ui.position.left / this.unit + this.item.offsetX,
        bottom:
          parseFloat(ui.helper.css("bottom")) / this.unit + this.item.offsetY
      });
    },
    _updateOnRotate: function (event, ui) {
      this.updateItem(this.index, {
        angle: ui.angle.current
      });
    }
  },
  mounted: function () {
    var element = jQuery(this.$el);
    if (this.item.movable) {
      element.draggable({
        containment: "#format-layer",

        start: (function (that) {
          return function (event, ui) {
            that.nonClickable = true;
          };
        })(this),
        drag: (function (that) {
          return function (event, ui) {
            that._updateOndrag(event, ui);
          };
        })(this),
        stop: (function (that) {
          return function (event, ui) {
            that._updateOndrag(event, ui);
            var bottom = ui.helper.css("bottom");
            ui.helper.css("bottom", bottom);
            ui.helper.css("top", "");

            setTimeout(function () {
              that.nonClickable = false;
            }, 1);
          };
        })(this)
      });
    }
    if (this.item.resizable) {
      element.resizable({
        containment: "#format-layer",
        handles: "n, e, s, w,se,sw,ne,nw",
        start: (function (that) {
          return function (event, ui) {
            ui.helper.css("top", ui.helper.css("top"));
            ui.helper.css("bottom", "");
            that.nonClickable = true;
          };
        })(this),
        resize: (function (that) {
          return function (event, ui) {
            that._updateOnResize(event, ui);
          };
        })(this),
        stop: (function (that) {
          return function (event, ui) {
            that._updateOnResize(event, ui);
            that._updateOndrag(event, ui);
            var bottom = ui.helper.css("bottom");
            ui.helper.css("bottom", bottom);
            ui.helper.css("top", "");

            setTimeout(function () {
              that.nonClickable = false;
            }, 1);
          };
        })(this)
      });
    }
    if (this.item.rotatable) {
      element.rotatable({
        angle: this.item.angle,
        handle: element.find(".ui-rotatable-handle"),
        start: (function (that) {
          return function (event, ui) {
            that.nonClickable = true;
          };
        })(this),
        rotate: (function (that) {
          return function (event, ui) {
            that._updateOnRotate(event, ui);
          };
        })(this),
        stop: (function (that) {
          return function (event, ui) {
            that._updateOnRotate(event, ui);
            setTimeout(function () {
              that.nonClickable = false;
            }, 1);
          };
        })(this)
      });
    }
  }
};
</script>
